import { notifySuccess } from '@/portainer/services/notifications';

import { DeleteButton } from '@@/buttons/DeleteButton';

import { ScopedKubeconfig } from '../types';
import { useRevokeScopedKubeconfigsMutation } from '../queries/useRevokeScopedKubeconfigsMutation';

export function TableActions({
  selectedItems,
}: {
  selectedItems: ScopedKubeconfig[];
}) {
  const revokeMutation = useRevokeScopedKubeconfigsMutation();

  return (
    <DeleteButton
      disabled={selectedItems.length === 0}
      confirmMessage="Do you want to revoke the selected scoped kubeconfig(s)? Any kubectl session using them stops working immediately, including one running right now."
      onConfirmed={handleRevoke}
      data-cy="scoped-kubeconfigs-revoke-button"
    >
      Revoke
    </DeleteButton>
  );

  function handleRevoke() {
    revokeMutation.mutate(selectedItems, {
      onSuccess() {
        notifySuccess('Success', 'Scoped kubeconfig(s) revoked');
      },
    });
  }
}
